import React, { useContext } from 'react';
import { useLocalizedStrings } from '../../Localization';
import { PublicConfigurationContext } from '../../Context';
import { useHistory } from 'react-router-dom';
import { Button, CompactSidebarNavTrigger, Heading,  NumberDisplay, Page } from '@aidkitorg/component-library';
import { AdminPanelNav } from '../AdminPanelApp';
import { usePayments } from '../../Contexts/PaymentsContext';
import { PaymentsDataTable } from './components/PaymentsDataTable';

export const PaymentsPage = () => {
  const L = useLocalizedStrings()
  const publicConfig = useContext(PublicConfigurationContext);
  const history = useHistory()

  const { enabledPayments } = usePayments();

  if (publicConfig && publicConfig.adminPanel === false){
    history.push("/");
  }

  const enabledPaymentsCard = <NumberDisplay
    className="max-w-56"
    title="Enabled Payments"
    value={enabledPayments} 
    unit="payments"
    iconName="PlayCircleIcon" 
    iconColor="blue"
  />

  // TODO: consolidate header footer into a AdminPanelShell Page or something
  
  const header = (
    <div>
      <div>
        <CompactSidebarNavTrigger />
      </div>
      <div>
        <Heading level="h1" className="m-0">Payments</Heading>
        <div className="text-lg text-gray-700">Track your program's performance and impact</div>
      </div>
    </div>
  )
  
  const footer = (
    <div className="w-full flex justify-between">
      <div>
        <Button variant="link" href="/privacy.html" openInNewWindow>
          {L.privacy_policy}
        </Button>
      </div>
      <div>
        <Button variant="link" href="/tos.html" openInNewWindow>
          {L.terms_and_conditions}
        </Button>
      </div>
    </div>
  )
  
  return (
    <Page 
      className="bg-gray-50"
      header={header}
      sidebar={
        <AdminPanelNav />
      }
      footer={footer}
    >
      <div className="flex flex-col gap-4">
        <div>
          {enabledPaymentsCard}
        </div>
        <div>
          <div className="border rounded-md p-4 bg-white">
            <PaymentsDataTable />
          </div>
        </div>
      </div>
    </Page>
  )
}